import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnChanges, Output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { BreakpointObserver } from '@angular/cdk/layout';
import { NgxGaugeModule } from 'ngx-gauge';
import { MatSelectModule } from '@angular/material/select';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { map, Observable, startWith } from 'rxjs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ICategory } from '@web-nx-ng-tsc/data-access';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';
import { ReplaceBucket } from '@web-nx-ng-tsc/util-func';

export enum ETireDecInc {
  INCREASE = 'inc',
  DECREASE = 'dec',
}
export interface TireSizeUp {
  up_size: string;
}
export interface TireSizeDown {
  down_size: string;
}

@Component({
  selector: 'web-promo-shared-pattern-lib-product-tire-detail-card',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatIconModule,
    CommonModule,
    NgxGaugeModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
  ],
  templateUrl: './lib-product-tire-detail-card.component.html',
  styleUrl: './lib-product-tire-detail-card.component.scss',
})
export class LibProductTireDetailCardComponent implements OnChanges {
  @Input() set data(value: any) {
    this.dataSignal.set(value);
  }

  @Input() set category(value: any) {
    this.categorySignal.set(value);
    this.loggingService.log('|||| categorySignal :: w=>', value);

    this.loggingService.log('|||| categorySignal :: w=>', this.categorySignal());
  }
  @Input() set dataTireSize(value: any) {
    if (value) {
      if (this.onChangesSignal() === 'up') {
        this.loggingService.log('|||| dataTireSize UP:: w=>', value.rows);
        this.filteredOptionsTireUp.set(value.rows);
      } else if (this.onChangesSignal() === 'down') {
        this.loggingService.log('|||| dataTireSize DOWN:: w=>', value.rows);
        this.filteredOptionsTireDown.set(value.rows);
      }
    }
  }
  @Input() set checkTire(value: ICategory) {
    // this.tire = value;
    this.tireCheck = value;
    this.loggingService.log('checkTire', value);
  }

  tireCheck!: ICategory;
  @Output() OnClickOpenpopup = new EventEmitter();

  @Output() emitDecIncTireSize = new EventEmitter();
  @Output() emitComparison = new EventEmitter();
  @Output() emitVideoLinkUrl = new EventEmitter();
  @Output() emitDataTireUpOrDown = new EventEmitter();
  @Output() emitDataSelectedTireSize = new EventEmitter();

  // inject
  private readonly loggingService = inject(LoggingService);
  private observer = inject(BreakpointObserver);
  public readonly replaceBucket = new ReplaceBucket();

  selectedTireSize = '';
  gaugeType: 'full' | 'semi' | 'arch' = 'semi';
  gaugeValue = 0;
  isMobileView = false;
  gaugeSize = signal<number>(120);
  tireDecInc = ETireDecInc;
  displayFnUp(tireSize: TireSizeUp): string {
    // this.loggingService.log('displayFnUp =>', tireSize);
    this.selectedTireSize = tireSize.up_size;

    return tireSize && tireSize.up_size ? tireSize.up_size : '';
  }
  displayFnDown(tireSize: TireSizeDown): string {
    // this.loggingService.log('displayFnDown =>', tireSize);
    this.selectedTireSize = tireSize.down_size;
    return tireSize && tireSize.down_size ? tireSize.down_size : '';
  }

  dataSignal = signal<any>(undefined);
  categorySignal = signal<string>('tire');
  onChangesSignal = signal<string>('');
  isAutoUpOpen = false;
  isAutoDownOpen = false;

  filteredOptionsUp?: Observable<TireSizeUp[]>;
  myControlTireUp = new FormControl<string | TireSizeUp>('');
  filteredOptionsTireUp = signal<TireSizeUp[]>([]);

  filteredOptionsDown?: Observable<TireSizeDown[]>;
  myControlTireDown = new FormControl<string | TireSizeDown>('');
  filteredOptionsTireDown = signal<TireSizeDown[]>([]);

  brandID!: number;
  modelCurrent!: string;

  constructor() {
    this.observer.observe('(max-width: 600px)').subscribe((res) => {
      this.isMobileView = res.matches;
      this.loggingService.log('Mobile?', this.isMobileView);
      if (this.isMobileView) {
        this.gaugeSize.set(95);
      } else {
        this.gaugeSize.set(140);
      }
    });
  }
  ngOnChanges() {
    if (this.onChangesSignal() === 'up') {
      this.filteredOptionsUp = this.myControlTireUp.valueChanges.pipe(
        startWith(''),
        map((value: TireSizeUp | string | null) => {
          this.loggingService.log('value Up=>', typeof value);
          const up_size = typeof value === 'string' ? value : value?.up_size;
          this.loggingService.log('up_size =>', up_size);
          this.loggingService.log('myControlTireUp =>', this.myControlTireUp);
          return up_size ? this._filterUp(up_size as string) : this.filteredOptionsTireUp().slice();
        })
      );
    } else if (this.onChangesSignal() === 'down') {
      this.filteredOptionsDown = this.myControlTireDown.valueChanges.pipe(
        startWith(''),
        map((value: TireSizeDown | string | null) => {
          this.loggingService.log('value Down=>', typeof value);
          const down_size = typeof value === 'string' ? value : value?.down_size;
          this.loggingService.log('down_size =>', down_size);
          this.loggingService.log('myControlTireDown =>', this.myControlTireDown);

          return down_size ? this._filterDown(down_size as string) : this.filteredOptionsTireDown().slice();
        })
      );
    }
  }

  onClickDecIncTireSize(btnType: ETireDecInc, data: any) {
    const DecInc = {
      type: btnType,
      data: data,
    };
    this.emitDecIncTireSize.emit(DecInc);
  }

  addToComparison(event: any) {
    this.emitComparison.emit(event);
  }
  onClickVideoLinkUrl(link_url: string) {
    this.emitVideoLinkUrl.emit(link_url);
  }

  onClickChangeTireSize(onChange: string) {
    if ((onChange === 'up' && this.isAutoUpOpen) || (onChange === 'down' && this.isAutoDownOpen)) {
      return;
    }
    this.loggingService.log('onClickChangeTireSize || lib product detail (up//down)', onChange);
    this.onChangesSignal.set(onChange);
    this.emitDataTireUpOrDown.emit(onChange);
  }

  onAutoUpOpened() {
    this.isAutoUpOpen = true;
  }

  onAutoUpClosed() {
    this.isAutoUpOpen = false;
  }

  onAutoDownOpened() {
    this.isAutoDownOpen = true;
  }

  onAutoDownClosed() {
    this.isAutoDownOpen = false;
  }

  private _filterUp(name: string): TireSizeUp[] {
    this.loggingService.log('name in _filter fnc Up=>', name);
    const filterValue = name.toLowerCase();
    this.loggingService.log('filterValue Up=>', filterValue);
    return this.filteredOptionsTireUp().filter((option) => option.up_size.toLowerCase().includes(filterValue));
  }
  private _filterDown(name: string): TireSizeDown[] {
    this.loggingService.log('name in _filter fnc Down=>', name);
    const filterValue = name.toLowerCase();
    this.loggingService.log('filterValue Down=>', filterValue);
    this.loggingService.log(
      'filterValue',
      this.filteredOptionsTireDown().filter((option) => option.down_size.toLowerCase().includes(filterValue))
    );
    this.loggingService.log('filteredOptionsTireDown selectedTireSize', this.selectedTireSize);

    return this.filteredOptionsTireDown().filter((option) => option.down_size.toLowerCase().includes(filterValue));
  }

  optionSelectedEmit(e: any, on: string) {
    this.loggingService.log('optionSelectedEmit :: e =>', e.option);
    this.loggingService.log('optionSelectedEmit :: on =>', on);
    const obj = {
      on: on,
      tireSize: e.option.value,
      brand: this.dataSignal().brand,
      model: this.dataSignal().product_model,
    };
    this.emitDataSelectedTireSize.emit(obj);
  }

  clickPopup() {
    this.OnClickOpenpopup.emit('');
  }
}
